import { ServerType } from '../server.interface';

// MT4/MT5 servers carry config server URL, autosync and per-stream trading-group settings;
// pluginless types (cTrader, Taker FIX API) expose a connection address and session ids instead.
export const isMtServerType = (type?: ServerType): boolean => type === ServerType.MT4 || type === ServerType.MT5;
